/* ESSNTL theme scripts — no dependencies */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Bag count ---------- */
  const setBagCount = (count) => {
    $$('[data-bag-count]').forEach((el) => { el.textContent = count; });
  };
  const refreshBag = () =>
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => { setBagCount(cart.item_count); return cart; })
      .catch(() => null);

  /* ---------- Mobile menu ---------- */
  const menu = $('[data-mobile-menu]');
  if (menu) {
    const open = () => {
      menu.classList.add('is-open');
      menu.removeAttribute('inert');
      document.body.classList.add('menu-open');
      $$('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      const first = $('a, button', menu);
      if (first) first.focus();
    };
    const close = () => {
      menu.classList.remove('is-open');
      menu.setAttribute('inert', '');
      document.body.classList.remove('menu-open');
      $$('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };
    $$('[data-menu-toggle]').forEach((b) => b.addEventListener('click', () => (menu.classList.contains('is-open') ? close() : open())));
    $$('[data-menu-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => { if (e.matches) close(); });
  }

  /* ---------- Add to bag (any form[data-add-form]) ---------- */
  const addToBag = async (form) => {
    const btn = $('[type="submit"]', form);
    const msg = $('[data-add-message]', form) || $('[data-add-message]', form.closest('[data-product-root]') || document.body);
    const label = btn ? btn.innerHTML : '';
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      await refreshBag();
      if (btn) {
        btn.innerHTML = btn.dataset.addedLabel || 'Added&nbsp;&nbsp;✓';
        setTimeout(() => { btn.innerHTML = label; }, 2400);
      }
      if (msg) msg.innerHTML = `Added to your bag. <a href="${root}cart">View bag →</a>`;
    } catch (err) {
      if (msg) msg.textContent = err.message;
      else alert(err.message);
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    addToBag(form);
  });

  /* ---------- PDP: gallery, variants, purchase options ---------- */
  $$('[data-product-root]').forEach((rootEl) => {
    const slides = $$('[data-slide]', rootEl);
    const thumbs = $$('[data-thumb]', rootEl);
    const counter = $('[data-slide-count]', rootEl);
    const go = (i) => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      if (counter) counter.textContent = `${String(i + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    // swipe on main image
    const stage = $('[data-stage]', rootEl);
    if (stage && slides.length > 1) {
      let x0 = null;
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const cur = slides.findIndex((s) => s.classList.contains('is-active'));
        if (Math.abs(dx) > 40) go((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
        x0 = null;
      });
    }

    const json = $('[data-product-json]', rootEl);
    const product = json ? JSON.parse(json.textContent) : null;
    const form = $('form[data-add-form]', rootEl);
    if (!product || !form) return;
    const idInput = $('input[name="id"]', form);
    const planInput = $('input[name="selling_plan"]', form);
    const select = $('[data-variant-select]', rootEl);
    const priceEl = $('[data-price]', rootEl);
    const onePrice = $('[data-one-time-price]', rootEl);
    const subPrice = $('[data-sub-price]', rootEl);
    const addBtn = $('[data-add-button]', rootEl);
    const fmt = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: rootEl.dataset.currency || 'GBP' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    };
    const current = () => product.variants.find((v) => String(v.id) === String(idInput.value)) || product.variants[0];
    const render = () => {
      const v = current();
      const sub = $('input[name="purchase_type"]:checked', rootEl);
      const isSub = sub && sub.value === 'subscription';
      let subCents = null;
      if (v.selling_plan_allocations && v.selling_plan_allocations.length) {
        subCents = v.selling_plan_allocations[0].price;
        if (planInput) planInput.value = isSub ? v.selling_plan_allocations[0].selling_plan_id : '';
      }
      if (priceEl) priceEl.textContent = fmt(isSub && subCents ? subCents : v.price);
      if (onePrice) onePrice.textContent = fmt(v.price);
      if (subPrice && subCents) subPrice.textContent = fmt(subCents);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available ? addBtn.dataset.label : addBtn.dataset.soldout;
      }
      if (planInput && !isSub) planInput.value = '';
    };
    if (select) select.addEventListener('change', () => { idInput.value = select.value; render(); });
    $$('input[name="purchase_type"]', rootEl).forEach((r) => r.addEventListener('change', render));
    if (planInput) planInput.value = '';
  });

  /* ---------- Flat-lay mobile swipe progress ---------- */
  $$('[data-flatlay]').forEach((wrap) => {
    const scroller = $('[data-flatlay-scroller]', wrap);
    const bars = $$('[data-flatlay-progress] span', wrap);
    if (!scroller || !bars.length) return;
    scroller.addEventListener('scroll', () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const ratio = max > 0 ? scroller.scrollLeft / max : 0;
      const idx = Math.min(bars.length - 1, Math.round(ratio * (bars.length - 1)));
      bars.forEach((b, i) => b.classList.toggle('is-active', i === idx));
    }, { passive: true });
  });

  /* ---------- Collection carousel arrows ---------- */
  $$('[data-carousel]').forEach((wrap) => {
    const track = $('[data-carousel-track]', wrap);
    const prev = $('[data-carousel-prev]', wrap);
    const next = $('[data-carousel-next]', wrap);
    if (!track) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 18 : 260);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Cart page quantity buttons ---------- */
  $$('[data-qty-change]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const qty = Math.max(0, parseInt(btn.dataset.qtyChange, 10));
      btn.setAttribute('aria-busy', 'true');
      await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      window.location.reload();
    });
  });

  /* ---------- Blog search toggle ---------- */
  $$('[data-search-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const wrap = btn.closest('.blog-cats__search');
      const input = $('input', wrap);
      if (!wrap.classList.contains('is-open')) {
        e.preventDefault();
        wrap.classList.add('is-open');
        input.focus();
      } else if (!input.value) {
        e.preventDefault();
        wrap.classList.remove('is-open');
      }
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  document.addEventListener('shopify:section:load', () => { $$('.reveal').forEach((el) => el.classList.add('is-visible')); });
})();
